import React from 'react'
import { Drawer, Typography, IconButton, Grid, Box } from '@the-platform-group/component-library'
import { Close as CloseIcon } from '@the-platform-group/component-library/Icons'

/**
 * BaseJobDrawer - Reusable drawer component with sticky footer
 *
 * @component
 * @param {Object} props
 * @param {boolean} props.open - Whether the drawer is open
 * @param {Function} props.onClose - Function to call when drawer closes
 * @param {string} props.title - Title to display in the header
 * @param {React.ReactNode} props.children - Main content area (scrollable)
 * @param {React.ReactNode} props.footer - Optional sticky footer content (e.g., action buttons)
 * @returns {JSX.Element}
 */
const BaseJobDrawer = ({ open, onClose, title, children, footer }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 600,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        },
      }}
    >
      {/* Header - Fixed at top */}
      <Box sx={{ px: 3, pt: 10, flexShrink: 0 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6">{title}</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>

      {/* Content - Scrollable */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          px: 3,
          pb: footer ? 0 : 3,
        }}
      >
        {children}
      </Box>

      {/* Footer - Sticky at bottom */}
      {footer && (
        <Box
          sx={{
            flexShrink: 0,
            px: 3,
            py: 1.5,
            borderTop: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.paper',
          }}
        >
          {footer}
        </Box>
      )}
    </Drawer>
  )
}

export default BaseJobDrawer
